// Capitalizes only the first letter of a string, lowercases the rest, and handles null/undefined gracefully.
export function capitalizeFirstLetter(str?: string | null): string {
  if (!str) return '';
  const lower = str.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

/** First letter of each word capital, rest lowercase. Underscores become spaces. */
export function capitalizeWords(str?: string | null): string {
  if (!str?.trim()) return "";
  return str
    .trim()
    .replace(/_/g, " ")
    .split(/\s+/)
    .map(word => capitalizeFirstLetter(word))
    .join(" ");
}



// Converts snake_case strings to Title Case with spaces
// Example: "full_name" -> "Full Name", "user_profile_picture" -> "User Profile Picture"
export function snakeCaseToTitleCase(str?: string | null): string {
  if (!str) return "";

  return str
    .split("_")
    .map(word => capitalizeFirstLetter(word))
    .join(" ");
}
